<template>
  <div style="background: #f2f2f6; height: calc(100vh - 60px);overflow-y:auto">
     <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/' }">{{$t("base.index")}}</el-breadcrumb-item>
  <el-breadcrumb-item>{{$t("index.device")}}</el-breadcrumb-item>
  <el-breadcrumb-item :to="{ path: '/EquipmentList' }">{{$t("index.gatewayList")}}</el-breadcrumb-item>
  <el-breadcrumb-item>{{$t("index.gatewayDetail")}}</el-breadcrumb-item>
</el-breadcrumb>
    <el-container >

      <el-main style="padding:30px;overflow:hidden">
        <el-alert
        v-if="!$store.state.project.online"
    :title="$t('device.offLineAlert')"
    type="error"
    effect="dark">
  </el-alert>
        <el-row>
          <el-descriptions size="mini" :column="4" style="color:rgb(255, 208, 75);padding:10px; height:100%;background:#ffffff;box-shadow: 0 0.31rem 1.69rem 0 rgba(0,0,0,0.04);border-radius: 0.56rem" :title="$t('device.deviceSummary')">
            <template slot="extra">
      <span style="color:red" v-show="!connect">{{$t('device.webOff')}}</span>
      <el-button v-if="$store.state.project.favoriteid" style="background: inherit;font-size: 16px; border: 0; color:rgb(255, 208, 75)" icon="el-icon-star-on" circle size="small" @click="editFavorite(0)"></el-button>
          <el-button v-else style="background: inherit;font-size: 16px; border: 0; color:rgb(255, 208, 75)" icon="el-icon-star-off" circle size="small" @click="editFavorite(1)"></el-button>
    </template>
            <el-descriptions-item :label="$t('device.projectName')"><el-button type="text" size="mini" style="height:18px;line-height:18px; font-size:12px" @click="editProject">{{(user.logintype==1?$store.state.project.factoryname:$store.state.project.fdealername)||$store.state.project.name}}<i class="el-icon-edit"></i></el-button></el-descriptions-item>
    <el-descriptions-item v-if="user.logintype!=3" :label="$t('base.dealer')"><span style="white-space: pre-wrap;">{{($store.state.project.dealername2&&user.factoryname!=$store.state.project.dealername)?($store.state.project.dealername2+'\n'):''}}{{$store.state.project.dealername}}</span></el-descriptions-item>
    <el-descriptions-item v-else :label="$t('base.factory')">{{$store.state.project.factoryname}}</el-descriptions-item>
    <el-descriptions-item :label="$t('device.customerPhone')">{{$store.state.project.mobile}}</el-descriptions-item>
     <el-descriptions-item :label="$t('device.address')">{{ $store.state.project.ipaddress||$store.state.project.city }}</el-descriptions-item>
    <el-descriptions-item :label="$t('device.gatewayOnline')">
        <img v-if="$store.state.project.iccid&&$store.state.project.online" style="margin-left:10px; width:20px;height:15px" :title="rate4gtext" :src="'../../static/images/icon/4g-'+rate4glevel+'.png'"/>
          <span v-else-if="!$store.state.project.online" style="color:red">{{$t('base.offline')}}</span>
        <span v-else>{{$t('base.online')}}</span>
    </el-descriptions-item>
   <el-descriptions-item :label="$t('device.simSet')">
      {{$store.state.project.price_plan_name}}
    </el-descriptions-item>
    <el-descriptions-item :label="$t('device.gatewayNo')">{{$store.state.project.no}}</el-descriptions-item>
    <el-descriptions-item :label="$t('device.srcaddress')">{{$store.state.project.srcaddress}}</el-descriptions-item>
    <el-descriptions-item :label="$t('device.protocol')">{{ $i18n.locale=='en'?($store.state.project.protocolname_en||$store.state.project.protocolname):$store.state.project.protocolname}}</el-descriptions-item>
    <el-descriptions-item :label="$t('device.deviceNo')">{{$store.state.project.deviceno}}</el-descriptions-item>
    <el-descriptions-item :label="$t('device.deviceError')">
        <span v-if="$store.state.device&&$store.state.device.errorcode&&!errorhide" :title="$i18n.locale=='en'?$store.state.device.errmsg_en:$store.state.device.errmsg" style="color:red;overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 14vw;">{{  $i18n.locale=='en'?$store.state.device.errmsg_en:$store.state.device.errmsg}}</span>
        <span v-else>{{$t('base.none')}}</span></el-descriptions-item>
         <el-descriptions-item :label="$t('device.deviceOnline')">
         <span v-if="!$store.state.device.online" style="color:red">{{$t('base.offline')}}</span>
        <span v-else>{{$t('base.online')}}</span></el-descriptions-item>
        <el-descriptions-item :label="$t('base.outerTemp')">{{weather.temp||'--'}}℃</el-descriptions-item>
        <el-descriptions-item :label="$t('base.outerHumid')">{{weather.humidity||'--'}}%</el-descriptions-item>
        <el-descriptions-item label="PM2.5">{{weather.pm25||'--'}}</el-descriptions-item>
</el-descriptions>

        </el-row>

          <el-tabs v-loading="loading" v-model="activeName" style="margin-top:20px;width:100%;" type="border-card">
    <el-tab-pane :lazy="true"  :label="$t('device.tab_setupParam')" name="first"><router-view style="height: 100%;width:100%;"  name="heatpumpC"/></el-tab-pane>
    <el-tab-pane :lazy="true" v-if="!loading" :label="$t('device.tab_runParam')" name="first2"><router-view style="height: 100%;width:100%;"  name="heatpump"/></el-tab-pane>
    <!-- <el-tab-pane v-if="user.isadmin||($store.state.permission.Devices&&$store.state.permission.Devices.Aircondition&&$store.state.permission.Devices.Aircondition.show)" label="配套面板" name="second"><router-view style="height: 100%;width:100%;"  name="aircondition"/></el-tab-pane> -->
    <el-tab-pane :lazy="true" :label="$t('device.tab_elec')" name="third"><router-view style="height: 100%;width:100%;"  name="acb"/></el-tab-pane>
    <el-tab-pane :lazy="true"  :label="$t('device.tab_report')" name="fourth"><router-view style="height: 100%;width:100%;"  name="report"/></el-tab-pane>
    <el-tab-pane :lazy="true"  :label="$t('device.tab_historyError')" name="six"><router-view style="height: 100%;width:100%;"  name="historyError"/></el-tab-pane>
    <el-tab-pane :lazy="true"  :label="$t('device.tab_optLog')" name="six4"><router-view style="height: 100%;width:100%;"  name="optLog"/></el-tab-pane>
      <el-tab-pane :lazy="true" :label="$t('device.tab_customer')" name="six3"><router-view style="height: 100%;width:100%;"  name="customerList"/></el-tab-pane>
       <el-tab-pane :lazy="true"  :label="$t('device.tab_mibee')" name="six1"><router-view style="height: 100%;width:100%;"  name="mibee"/></el-tab-pane>
       <el-tab-pane :lazy="true"  :label="$t('device.tab_timing')" name="eight"><router-view style="height: 100%;width:100%;"  name="timing"/></el-tab-pane>
     <el-tab-pane :lazy="true" :label="$t('device.tab_flow')" name="six2"><router-view style="height: 100%;width:100%;"  name="adv"/></el-tab-pane>
     <el-tab-pane :lazy="true" :label="$t('device.tab_update')" name="seven"><router-view style="height: 100%;width:100%;"  name="versionLog"/></el-tab-pane>
  </el-tabs>
      </el-main>
      <el-aside v-if="$store.state.debugger" width="50%" style="padding-right:20px;padding-top:30px">
        <div style="position:fixed; width:42%;height:calc(100% - 180px); max-height:700px;border-radius:10px;background:#fff;padding-top:10px">
          <span style="margin:10px;font-size:16px; color:#333;font-weight:bolder"> {{$t('device.debugger')}}</span>
          <el-button size="mini" type="success" @click="openDebug()">{{$t('base.on')}}</el-button>
          <el-button size="mini" type="info" @click="closeDebug()">{{$t('base.pause')}}</el-button>
          <el-button size="mini" type="primary" @click="debuglog=[]">{{$t('base.clear')}}</el-button>
          <el-button size="mini" type="danger" @click="closeDebug(true)">{{$t('base.off')}}</el-button>
          <el-row style="margin-top:5px"><span style="margin-left:10px;color:red;"> !!!{{$t('device.debugInfo')}}</span></el-row>
          <el-row>
            <el-descriptions :labelStyle="{width:'200px'}"  :contentStyle="{width:'200px'}" :column="3" size="mini"  border>
              <el-descriptions-item label="设备">
                <el-select
                size="mini"
                v-model="debugobj.deviceid"
                v-if="$store.state.devicelist.length>1||$store.state.slavenum"
              >
                <el-option
                  v-for="item in $store.state.devicelist"
                  :key="item.innerid"
                  :label="item.name"
                  :value="item.deviceid"
                  v-if="item.subdevs<=($store.state.slavenum+1)||item.type!='heatpump'||item.hide==1"
                >
                </el-option>
              </el-select>
              </el-descriptions-item>
              <el-descriptions-item label="功能码">
                <el-select
                size="mini"
                v-model="debugobj['9200']"
                @change="sendDp('9200')"
              >
                <el-option  label="请设置" :value="0" ></el-option>
                <el-option  label="01读线圈(1x)" :value="1" ></el-option>
                <el-option  label="02读离散(2x)" :value="2" ></el-option>
                <el-option  label="03读保持(4x)" :value="3" ></el-option>
                <el-option  label="04读输入(3x)" :value="4" ></el-option>
                <el-option  label="05写线圈" :value="5" ></el-option>
                <el-option  label="06写保持" :value="6" ></el-option>
                <el-option  label="0F写线圈" :value="15" ></el-option>
                <el-option  label="10写保持" :value="15" ></el-option>
              </el-select>
              </el-descriptions-item>
              <el-descriptions-item label="目标地址">
                <el-input-number
                size="mini"
                v-model="debugobj['9201']"
                :min="0"
                :max="65535"
                :step="1"
                @change="sendDp('9201')"
              >
              </el-input-number>
              </el-descriptions-item>
              <el-descriptions-item label="写入值">
                <el-input-number size="mini"
                v-model="debugobj['9202']"
                :min="-65535"
                :max="65535"
                :step="1"
                @change="sendDp('9202')"
              ></el-input-number>
              </el-descriptions-item>
              <el-descriptions-item label="执行命令">
                <el-button size="small" type="success" @click="sendDp('9203')">执行</el-button>
              </el-input-number>
              </el-descriptions-item>
              <el-descriptions-item label="执行状态">
                  {{getMDB(debugobj['9204'])}}
              </el-descriptions-item>
              <el-descriptions-item label="结果(无符号)">
                {{debugobj['9205']}}
              </el-descriptions-item>
              <el-descriptions-item label="结果(有符号)">
                {{debugobj['9206']}}
              </el-descriptions-item>
            </el-descriptions>
          </el-row>
          <el-row id="dialogdebugger" style="height:calc(100% - 195px);background:#555;margin:10px;overflow-y:auto;overflow-x:hidden">
            <el-col style="fonrt-size:14px; padding:3px;color:lightgreen;word-break:break-all;" v-for="(item,i) in debuglog" :key="i">{{item}}</el-col>
          </el-row>
        </div>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
import Vue from 'vue'
let intervalid
let timeoutid
export default {
  name: 'Devices',
  data () {
    return {
      connect: false,
      activeName: 'first2',
      rate4glevel: 0,
      rate4gtext: '-',
      projects: [],
      user: {},
      projectid: '',
      loading: false,
      errorhide: false,
      weather: {},
      debugobj: {
        deviceid: '',
        '9200': 0,
        '9201': 0,
        '9202': 0,
        '9203': 1,
        'mdbg_sta': '',
        'mdbg_read': 0,
        'mdbg_reads': 0
      },
      debuglog: []
    }
  },
  watch: {
    activeName (val) {
      console.log(val)
      let self = this
      if (timeoutid) {
        clearTimeout(timeoutid)
        timeoutid = setTimeout(function () {
          self.$alert(self.$t('device.saveFlowTip'), self.$t('base.info'), {
            type: 'warning',
            confirmButtonText: self.$t('base.confirm')
          })
          self.Common.mqttSend(self.$store.state.device.srcaddress, {logout: 'logout'})
          self.Common.closeMqtt()
          self.connect = false
          timeoutid = null
        }, 60 * 1000 * 10)
      }
    }
  },
  computed: {
    // device () {
    //   if (this.$store.state.devicelist.length == 0) {
    //     return {}
    //   }
    //   return this.$store.state.devicelist.filter(d => { return d.type == 'heatpump'&&d.subdev==1 })[0]
    // }
    // dplist () {
    //   if (this.device) {
    //     return this.device.
    //   } else {
    //     return []
    //   }
    // }
  },
  mounted: function () {
    var self = this
    this.activeName = 'first2'
    this.$store.state.messagelog = []
    let user = window.localStorage.getItem('customer')
    if (user) {
      if (this.user.logintype == 2) {
        let dpermission = window.localStorage.getItem('dpermission')
        if (dpermission) {
          dpermission = JSON.parse(dpermission)
          if (dpermission && dpermission.heatpump && dpermission.heatpump.errorhide) {
            this.errorhide = true
          }
        }
      }

      this.loading = true
      this.selectProject(this.$route.params.equipmentid)
      user = JSON.parse(user)
      this.Common.connentMqtt(this.Common.newGuid())
      this.connect = true
      self.user = user
      // Vue.axios
      //   .post('/api/errorcode/list', {})
      //   .then((res) => {
      //     if (res.data.errcode == 0) {
      //       self.errorlist = res.data.msgbody.dev_errorcode
      //     }
      //   })

      // 停留在设备详情页10分钟没操作则断开连接
      timeoutid = setTimeout(function () {
        self.$alert(self.$t('device.saveFlowTip'), self.$t('base.info'), {
          type: 'warning',
          confirmButtonText: self.$t('base.confirm')
        })
        self.Common.mqttSend(self.$store.state.device.srcaddress, {logout: 'logout'})
        self.Common.closeMqtt()
        self.connect = false
        timeoutid = null
      }, 60 * 1000 * 10)
    } else {
      this.$message({
        message: this.$t('base.noSession'),
        type: 'warning'
      })
      this.$router.push({ name: 'Login' })
    }
  },
  beforeDestroy:function () {
    console.log('1')
    this.Common.mqttSend(this.$store.state.device.srcaddress, {logout: 'logout'})
    this.Common.closeMqtt()
    this.$store.state.device = {}
    this.$store.state.deviceinnerid = ''
    this.$store.state.devicelist = []
    this.$store.state.slavenum = 99
    this.$store.state.project = {}
    this.$store.state.messagelog = []
    
    if (intervalid) {
      clearInterval(intervalid)
      intervalid = null
    }
    if (timeoutid) {
      clearTimeout(timeoutid)
      timeoutid = null
    }
    console.log('1')
  },
  destroyed: function () {
    console.log('2')
  },
  methods: {
    selectProject (equipmentid) {
      var self = this
      self.rate4glevel = 0
      self.rate4gtext = '-'
      Vue.axios
        .post('/equipment/device/all', {
          equipmentid: equipmentid,
          hideValue: 1,
          save: 1
        })
        .then((res) => {
          if (res.data.errcode === 0) {
            console.log(res.data)
            res.data.msgbody.deviceList.forEach(d => {
              d.dplist = res.data.msgbody.dpList.filter(x => { return x.protocolid == d.protocolid })
              d.dplist.forEach(dp => {
                if (d[dp.name] == undefined) {
                  d[dp.name] = null
                } else if (d.subdevs == 1 && dp.name == 'slavenum' && d[dp.name]) {
                  self.$store.state.slavenum = d[dp.name]
                } else if (d.subdevs == 1 && dp.name == 'modelnum' && d[dp.name]) {
                  self.$store.state.slavenum = d[dp.name] - 1
                }
              })
            })
            self.$store.commit('updateDeviceList', res.data.msgbody.deviceList)
            if (res.data.msgbody.deviceList && res.data.msgbody.deviceList.length > 0) {
              self.$store.state.device = res.data.msgbody.deviceList[0] || {}
              self.$store.state.deviceinnerid = this.$store.state.device.innerid
              self.debugobj.deviceid = this.$store.state.device.deviceid
              setTimeout(() => {
                self.Common.mqttReceive(['app/' + self.Common.mqttClientid + '/' + res.data.msgbody.deviceList[0].srcaddress, 'd/' + res.data.msgbody.deviceList[0].srcaddress + '/b', 'device/' + res.data.msgbody.deviceList[0].srcaddress + '/broadcast', '*/*/' + self.Common.mqttClientid, 'device/' + res.data.msgbody.deviceList[0].srcaddress + '/devupdateresp'],
                  function (msg) {
                    let router = msg.destinationName.split('/')
                    console.log((router[1] == self.Common.mqttClientid ? '网页模拟接受' : '网关返回') + Math.round(new Date().getTime() / 1000) + ':' + msg.payloadString)
                    self.$store.state.messagelog.push('[' + new Date().Format('HH:mm:ss') + '] ' + (router[1] == self.Common.mqttClientid ? '模拟接受' : '网关返回') + ':' + msg.payloadString)
                    if (self.$store.state.messagelog.length > 500) {
                      self.$store.state.messagelog.splice(0, 1)
                    }
                    if (router[1] == self.Common.mqttClientid) {
                      return
                    }
                    if (router.length !== 3 || (router[1] !== res.data.msgbody.deviceList[0].srcaddress && router[1] != '00000000000000000000000000000001' && router[1] != '1')) {
                      console.log('接收到无效数据：' + msg.destinationName)
                      return
                    }
                    msg = JSON.parse(msg.payloadString)
                    for (var key in msg) {
                      if (key === 'dpmonitor' || key === 'dpchange') {
                        // debugger
                        var dev = self.$store.state.devicelist.filter((x) => {
                          return x.deviceid == (msg[key].srcdev || msg[key].devid)
                        })
                        if (dev && dev.length > 0) {
                          if (msg[key].dpid == 9000) {
                            dev[0].online = msg[key].data
                          } else if (msg[key].dpid == 9003) {
                          } else if (msg[key].dpid == 9009) {
                            if (self.errorhide) {
                              console.log('666')
                              dev[0].errorcode = ''
                              dev[0].errmsg = ''
                              return
                            }
                            console.log('9009')
                            let error = '故障：' + msg[key].data
                            let errorcode = msg[key].data
                            if (self.errorlist && self.errorlist.length > 0) {
                              if (msg[key].exdata && msg[key].exdata.length > 1) {
                                let codeList = []
                                let msgList = []
                                msg[key].exdata.forEach(er => {
                                  let e = self.errorlist.filter(x => {
                                    return x.code == er
                                  })
                                  if (e && e.length > 0) {
                                    error = e[0].desc
                                    if (e[0].errcode) {
                                      errorcode = e[0].errcode
                                    }
                                  }
                                  msgList.push(error)
                                  codeList.push(errorcode)
                                })
                                errorcode = codeList.join(',')
                                error = msgList.join(',')
                              } else {
                                let e = self.errorlist.filter(x => {
                                  return x.code == msg[key].data
                                })
                                if (e && e.length > 0) {
                                  error = e[0].desc
                                  if (e[0].errcode) {
                                    errorcode = e[0].errcode
                                  }
                                }
                              }
                            }
                            console.log('guzhng:' + errorcode)
                            dev[0].errorcode = errorcode
                            dev[0].errmsg = error
                            dev[0].errtime = (new Date()).Format('yyyy/MM/dd HH:mm:ss')
                          } else {
                            let dp = dev[0].dplist.filter((d) => {
                              return d.dpid == msg[key].dpid
                            })
                            if (dp && dp.length > 0) {
                              if (dp[0].name == 'lgtpwr' || dp[0].name == 'lnrdimpwr') {
                                dev[0].power = msg[key].data
                              } else if (dp[0].name === 'slavenum' && dev[0].subdevs === 1) {
                                self.$store.state.slavenum = Math.round(msg[key].data * 10) / 10
                              } else if (dp[0].name === 'modelnum' && dev[0].subdevs === 1) {
                                self.$store.state.slavenum = Math.round(msg[key].data * 10) / 10 - 1
                              } else if (dp[0].name == 'softver') {
                                if (self.$store.state.project.no.substring(0, 3).toLowerCase() === 'mst') {
                                  dev[0][dp[0].name] = 'V' + (Math.round(msg[key].data * 10) / 10).toString(16).split('').join('.')
                                } else {
                                  dev[0][dp[0].name] = 'V' + msg[key].data
                                }
                                dev[0].version2 = dev[0][dp[0].name]
                              } else {
                                let rate = 10
                                if (dp[0].step && dp[0].step < 0.1) {
                                  rate = Math.round(1 / dp[0].step)
                                }
                                dev[0][dp[0].name] = Math.round(msg[key].data * rate) / rate
                              }
                            }
                            if (msg[key].dipid >= 9204 && msg[key].dpid <= 9206 && dev[0].deviceid == self.debugobj.deviceid) {
                              self.debugger[key] = msg[key].data
                            }
                          }
                        }
                      } else if (key == 'get4ginfo') {
                        self.rate4glevel = msg.get4ginfo.rssiLevel
                        self.rate4gtext = msg.get4ginfo.rssiDesc
                      } else if (key == 'dpsync' || key == 'x') {
                        if (key == 'x') {
                          // 构建成dpsync
                          msg.dpsync = []
                          msg.x.forEach(d => {
                            let obj = {
                              devid: d.i || 17563905,
                              dplist: {}
                            }
                            d.d.forEach((item, index) => {
                              obj.dplist[item + ''] = d.v[index]
                            })
                            msg.dpsync.push(obj)
                          })
                        }
                        msg.dpsync.forEach(o => {
                          for (var key in o.dplist) {
                            var dev = self.$store.state.devicelist.filter((x) => {
                              return x.deviceid == o.devid
                            })
                            if (dev && dev.length > 0) {
                              if (parseInt(key) == 9000) {
                                dev[0].online = o.dplist[key]
                              } else if (parseInt(key) == 9003) {
                              } else if (parseInt(key) == 9009) {
                                if (self.errorhide) {
                                  console.log('666')
                                  dev[0].errorcode = ''
                                  dev[0].errmsg = ''
                                  return
                                }
                                let error = ''
                                let errorcode = o.dplist[key]
                                var erroritem = self.errorlist.filter(x => {
                                  return x.protocolid.indexOf(dev[0].protocolid) >= 0
                                })
                                if (erroritem && erroritem.length > 0) {
                                  let e = erroritem[0].errorlist.filter(x => {
                                    return x.code == o.dplist[key]
                                  })
                                  if (e && e.length > 0) {
                                    error = e[0].desc
                                    if (e[0].errcode) {
                                      errorcode = e[0].errcode
                                    }
                                  }
                                }
                                dev[0].errorcode = errorcode
                                dev[0].errmsg = error
                                dev[0].errtime = (new Date()).Format('yyyy/MM/dd HH:mm:ss')
                              } else {
                                let dp = dev[0].dplist.filter((d) => {
                                  return d.dpid == parseInt(key)
                                })
                                if (dp && dp.length > 0) {
                                  // let rate = 10
                                  // if (dp[0].step && dp[0].step < 0.1) {
                                  //   rate = Math.round(1 / dp[0].step)
                                  // }
                                  dev[0][dp[0].name] = o.dplist[key]// isNan(o.dplist[key])?o.dplist[key]:(Math.round(o.dplist[key] * rate) / rate)
                                  if (dp[0].name == 'lgtpwr' || dp[0].name == 'lnrdimpwr') {
                                    dev[0].power = o.dplist[key]
                                  } else if (dp[0].name === 'slavenum' && dev[0].subdevs === 1) {
                                    self.$store.state.slavenum = Math.round(o.dplist[key] * 10) / 10
                                  } else if (dp[0].name === 'modelnum' && dev[0].subdevs === 1) {
                                    self.$store.state.slavenum = Math.round(o.dplist[key] * 10) / 10 - 1
                                  } else if (dp[0].name === 'softver') {
                                    if (self.$store.state.project.no.substring(0, 3).toLowerCase() === 'mst') {
                                      dev[0][dp[0].name] = 'V' + (Math.round(o.dplist[key] * 10) / 10).toString(16).split('').join('.')
                                    } else {
                                      dev[0][dp[0].name] = 'V' + o.dplist[key]
                                    }
                                    dev[0].version2 = dev[0][dp[0].name]
                                  }
                                }
                              }
                            }
                          }
                        })
                      } else if (key == 'protocolUpdate') {
                        if (msg.protocolUpdate.status == -1) {
                          self.$message({
                            message: msg.protocolUpdate.errmsg,
                            type: 'error'
                          })
                        } else {
                          self.$message({
                            message: msg.protocolUpdate.errmsg,
                            type: 'success'
                          })
                          // let obj = { upjsonfile: {filename: 'Modbus.json', data: JSON.parse(msg.protocolUpdate.obj.modbus), cfgver: 1, setsn: msg.protocolUpdate.obj.newcode, reboot: 'en'}}
                          self.Common.mqttSend(res.data.msgbody.deviceList[0].srcaddress, msg.protocolUpdate.obj)
                        }
                      } else if (key == 'upjsonfile') {
                        if (msg.upjsonfile.status == 'ok') {
                          self.$message({
                            message: '网关生效完成，重新加载设备信息',
                            type: 'success'
                          })
                          self.loading = true
                          setTimeout(() => {
                            self.selectProject(self.$route.params.equipmentid)
                          }, 5000)
                        } else {
                          self.$message({
                            message: '网关变更失败',
                            type: 'error'
                          })
                        }
                      } else if (key == 'fota') {
                        if (msg.fota === 'ok') {
                          self.$alert('后台升级需要30秒，结束后手动刷新页面获取新版本号', this.$t('base.info'), {
                            confirmButtonText: this.$t('base.confirm')
                          })
                        } else {
                          self.$message({
                            showClose: true,
                            message: '固件升级失败',
                            type: 'error'
                          })
                        }
                      } else if (key == 'devupdateresp') {
                        var dev = self.$store.state.devicelist.filter((x) => {
                          return x.deviceid == msg[key].devid
                        })
                        if (dev && dev.length > 0) {
                          self.$set(dev[0], 'percentage', msg.devupdateresp.progress)
                          self.$set(dev[0], 'status', msg.devupdateresp.status)
                        }
                      } else if (key == 'debuglog') {
                        let now = new Date()
                        self.debuglog.push('[' + now.Format('HH:mm:ss') + '] ' + atob(msg.debuglog))
                        setTimeout(() => {
                          let div = document.getElementById('dialogdebugger')
                          div.scrollTop = div.scrollHeight
                        }, 100)
                      }
                      self.$forceUpdate()
                    }
                  })

                if (intervalid) {
                  clearInterval(intervalid)
                  intervalid = null
                }
                intervalid = setInterval(() => {
                  self.Common.mqttSend(res.data.msgbody.deviceList[0].srcaddress, {sysheart: 'null'})
                }, 50000)
              }, 0)
              // if (res.data.msgbody[0].srcaddress.length != 8) {
              setTimeout(() => {
                self.Common.mqttSend(res.data.msgbody.deviceList[0].srcaddress, {getAllDevAllDpSta: 'save'})
              }, 3000)
              // }
              setTimeout(() => {
                self.Common.mqttSend(res.data.msgbody.deviceList[0].srcaddress, {get4ginfo: ''})
              }, 3000)
            }
            self.$forceUpdate()
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
          this.loading = false
        })
      Vue.axios
        .post('/equipment/query', {
          innerid: equipmentid
        })
        .then((res) => {
          if (res.data.errcode === 0) {
            if (res.data.msgbody.firmwareverson) {
              let versionno = 0
              let version = res.data.msgbody.firmwareverson
              version = version.replace(/V/g, '')
              version = version.split('.')
              if (version.length == 3) {
                versionno = parseInt(version[0]) * 1000000 + parseInt(version[1] * 1000) + parseInt(version[2])
              }
              res.data.msgbody.versionno = versionno
            }
            Vue.axios
              .post('/api/errorcode/query', {protocolid: res.data.msgbody.protocolcode})
              .then((resErr) => {
                if (resErr.data.errcode == 0) {
                  self.errorlist = resErr.data.msgbody
                }
              })
            Vue.axios
              .post('/api/weather', {weaid: res.data.msgbody.city})
              .then((reswea) => {
                if (reswea.data.errcode == 0 && reswea.data.msgbody) {
                  self.weather = reswea.data.msgbody
                }
              })
            self.$store.commit('updateProject', res.data.msgbody)
            if (!res.data.msgbody.projectid) {
              this.$message({
                showClose: true,
                message: '当前网关无工程配置信息',
                type: 'warning'
              })
            }
            if (res.data.msgbody.iccid && res.data.msgbody['4gstatus']) {
              let info = JSON.parse(res.data.msgbody['4gstatus'])
              self.rate4glevel = info.rssiLevel
              self.rate4gtext = info.rssiDesc
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
    },
    editProject () {
      let self = this
      this.$prompt(this.$t('device.newProjectName'), this.$t('base.info'), {
        confirmButtonText: this.$t('base.confirm'),
        cancelButtonText: this.$t('base.cancel'),
        inputValue: (self.user.logintype == 1 ? self.$store.state.project.factoryname : self.$store.state.project.fdealername) || self.$store.state.project.name
      }).then(({ value }) => {
        if (value) {
          this.$store.state.project.factoryname = value
          this.$store.state.project.fdealername = value
          Vue.axios
            .post('/equipment/update', {innerid: this.$store.state.project.innerid, factoryname: this.$store.state.project.factoryname, fdealername: this.$store.state.project.fdealername})
            .then((res) => {
              if (res.data.errcode === 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('base.saveSuccess'),
                  type: 'success'
                })
                this.$forceUpdate()
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || this.$t('base.systemError'),
                  type: 'error'
                })
              }
            })
          this.$forceUpdate()
        }
      })
    },
    editFavorite (type) {
      Vue.axios
        .post('/equipment/favorite/edit', {type: type, equipmentid: this.$route.params.equipmentid })
        .then((res) => {
          if (res.data.errcode == 0) {
            if (type) {
              this.$store.state.project.favoriteid = '1'
            } else {
              this.$store.state.project.favoriteid = ''
            }
            this.$message({
              showClose: true,
              message: this.$t('base.saveSuccess'),
              type: 'success'
            })
            this.$forceUpdate()
          } else {
          }
        })
    },
    sendDp (tag) {
      let msg = {
        devdpmsg: {
          devid: this.debugobj.deviceid,
          dpid: parseInt(tag),
          data: this.debugobj[tag]
        }
      }
      this.Common.mqttSend(this.$store.state.device.srcaddress, msg)
    },
    openDebug () {
      this.Common.mqttSend(this.$store.state.device.srcaddress, {'debuglevel': 6})
      this.Common.mqttSend(this.$store.state.device.srcaddress, {'monitorlog': 1})
    },
    closeDebug (close) {
      this.Common.mqttSend(this.$store.state.device.srcaddress, {'debuglevel': 5})
      this.Common.mqttSend(this.$store.state.device.srcaddress, {'monitorlog': 0})
      if (close) {
        this.$store.state.debugger = false
      }
    },
    getMDB (value) {
      switch (value) {
        case 0:
          return '空闲中'
        case 1:
          return '正在执行'
        case 2:
          return '执行成功'
        case 3:
          return '执行失败'
        case 4:
          return '功能码设置成功'
        case 5:
          return '地址设置成功'
        case 6:
          return '写入值设置成功'
        case 7:
          return '请先设置功能码'
        case 8:
          return '请先设置地址[0-65535]'
        case 9:
          return '请先设置写入值[0-65535]'
      }
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title{
  text-align: left;
  padding-left:3.5rem;
  font-size:0.9rem;
  font-weight: bold;
  color:#666666;
}

.text{
   text-align: left;
  font-size:0.825rem;
  font-weight: bold;
  color:#999999;
  overflow: hidden;
  text-overflow:ellipsis;
  word-break: keep-all;
}

.el-main{
  position: relative;
}
.del-drawer{
  background: #f9f9f9;
}
.el-drawer:focus {
    outline: none;
}
.el-card{
width:80%;
margin-left:10%;
margin-top: 15%;
height:80%
}

.allcontrol{
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
  margin-bottom: 5px;
}

.allcontrolimg{
  width:40px;
  height:40px;
  background-size: 100% 100%;
  margin-bottom: 5px;
}

.allcontrolimg_small{
  margin-top: 5px;
  width:20px;
  height:20px;
  background-size: 100% 100%;
  margin-bottom: 5px;
}
.el-table__row .el-table_1_column_5   {
  color: crimson;
}
.bb {
  position: relative;
}
.aa {

  position: absolute;
  top: 0px;
  width: 200px;
  text-align: left;
  z-index:9999;
}
.el-table >>> .el-checkbox__input {
  margin-left: 40px;
}
.el-table >>> .cell {
  padding: 0;
}
/* .el-table >>> .el-table__column-filter-trigger {
  margin-right: 30px;
}
.el-table >>> .el-tag.el-tag--success {
  margin-right: 30px;
} */
.el-select {
  padding: 0 12px;
}

.avatar-uploader {
    display: inline-block;
    width: 200px;
    height: 120px;
    vertical-align: top;
}
.avatar-uploader >>> .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:200px;
}
.avatar-uploader >>> .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 120px;
    line-height:120px;
    text-align: center;
}
.avatar {
    width: 100%;
    height: 120px;
    display: block;
}
</style>

<style>
.el-tabs--border-card{
  border:0 !important
}

.el-tabs__header{
  border-bottom:0  !important;
}

.el-tabs--border-card>.el-tabs__header .el-tabs__item{
border-radius: 10px 10px 0px 0px !important;
border-bottom: 0 !important;
}

.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
border-bottom: 0 !important;
}

.el-tabs__content{
  padding:0 !important;
  width:100%;
  height:calc(100% - 39px);

}

.el-tab-pane{
  width:100%;
  height:100%
}
</style>



// WEBPACK FOOTER //
// src/components/Devices/Index.vue